import React, { useState } from "react";
import { Box, InputAdornment, TextField } from "@mui/material";
import { ReactComponent as ShowIcon } from "assets/images/icons/icn_input_show_hover.svg";
import { ReactComponent as HideIcon } from "assets/images/icons/icn_input_hide.svg";
import { getDefaultTextFieldProp } from "../../theme";
import modalStyle from "../modal.module.scss";

const AuthenticationFields = ({ username, setUsername, password, setPassword }) => {
  const [isPassword, setIsPassword] = useState(false);

  return (
    <>
      <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center">
        <Box className={modalStyle["field-container"]} style={{ marginBottom: "10px" }}>
          <Box style={{ marginRight: "30px" }}>Username</Box>
          <Box className={modalStyle.item}>
            <Box style={{ width: "300px" }}>
              <TextField
                fullWidth
                placeholder=""
                type="text"
                value={username}
                autoComplete="new-password"
                onChange={(event) => setUsername(event.target.value)}
                sx={{ ...getDefaultTextFieldProp().sx }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center">
        <Box className={modalStyle["field-container"]}>
          <Box style={{ marginRight: "30px" }}>Password</Box>
          <Box className={modalStyle.item}>
            <Box style={{ width: "300px" }}>
              <TextField
                fullWidth
                placeholder=""
                type={isPassword ? "text" : "password"}
                value={password}
                autoComplete="new-password"
                onChange={(event) => setPassword(event.target.value)}
                sx={{ ...getDefaultTextFieldProp().sx }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {isPassword ? (
                        <ShowIcon onClick={() => setIsPassword(false)} style={{ cursor: "pointer" }} />
                      ) : (
                        <HideIcon onClick={() => setIsPassword(true)} style={{ cursor: "pointer" }} />
                      )}
                    </InputAdornment>
                  ),
                }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default AuthenticationFields;
